export default "__VITE_ASSET__DZGEf7Vx__"